export type Environment = 'production' | 'staging';

export interface EnvironmentConfig {
  label: string;
  url: string;
  wsUrl: string;
  color: string;
  badgeColor: string;
}

export const ENVIRONMENTS: Record<Environment, EnvironmentConfig> = {
  production: {
    label: 'Production',
    url: 'https://app.cway.se',
    wsUrl: 'wss://app.cway.se',
    color: 'text-green-600 dark:text-green-400',
    badgeColor: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 border-green-300 dark:border-green-700',
  },
  staging: {
    label: 'Staging',
    url: 'https://staging.cway.se',
    wsUrl: 'wss://staging.cway.se',
    color: 'text-yellow-600 dark:text-yellow-400',
    badgeColor: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200 border-yellow-300 dark:border-yellow-700',
  },
};

const STORAGE_KEY = 'cway_environment';

export class EnvironmentService {
  private static currentEnvironment: Environment = 'production';

  static initialize() {
    const stored = localStorage.getItem(STORAGE_KEY) as Environment;
    if (stored && ENVIRONMENTS[stored]) {
      this.currentEnvironment = stored;
    }
    console.log('[Environment] Initialized:', this.currentEnvironment);
  }

  static get(): Environment {
    return this.currentEnvironment;
  }

  static set(env: Environment) {
    if (!ENVIRONMENTS[env]) {
      console.error('[Environment] Invalid environment:', env);
      return;
    }
    this.currentEnvironment = env;
    localStorage.setItem(STORAGE_KEY, env);
    console.log('[Environment] Changed to:', env);
  }

  static getConfig(): EnvironmentConfig {
    return ENVIRONMENTS[this.currentEnvironment];
  }

  static getUrl(): string {
    return ENVIRONMENTS[this.currentEnvironment].url;
  }

  static getWsUrl(): string {
    return ENVIRONMENTS[this.currentEnvironment].wsUrl;
  }

  static getLabel(): string {
    return ENVIRONMENTS[this.currentEnvironment].label;
  }
}

// Initialize on import
EnvironmentService.initialize();
